import styled from 'styled-components';
import {
  TableStyled,
} from '~/Components/Styled';

export const Table = styled(TableStyled)`
  margin-top: 5px;
  tbody tr:hover {
    background-color: ${props => props.theme.colors.lighterWhite}
  }
  tbody tr td {
    padding: 5px 5px 5px 15px;
    span {
      font-size: 14px;
      color: ${props => props.theme.colors.dark};
      font-weight: 500;
      font-family: 'Simplon Oi', -apple-system, BlinkMacSystemFont, 'Segoe UI',
        'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
        'Helvetica Neue', sans-serif !important;
    }
  }
`;

export const ButtonSelectCategory = styled.button.attrs({
  type: 'button',
})`
  background-color: transparent;
  font-size: 14px;
  border: 0;
  color: ${props => (props.active ? props.theme.colors.primary : props.theme.colors.dark)};
  outline: none;
  font-weight: 500;
`;
